import React from 'react';
import { Button, Space, DatePicker } from 'antd';

import {CForm,CFormInput,CFormLabel,CFormText,CTableDataCell,CTableRow,CTableHeaderCell,CTable,CTableBody,CTableHead,CDropdown,CDropdownItem,CDropdownMenu,CDropdownToggle} from '@coreui/react';



function App(){
  return(
   
      <div style={{ padding: '0 24px' }}>
       <CForm>
  <CTable>
  <CTableHead>
    <CTableRow>
      <CTableHeaderCell scope="col">Survey Agent Name</CTableHeaderCell>
      <CTableHeaderCell scope="col">Lead ID</CTableHeaderCell>
      <CTableHeaderCell scope="col">Auto Generated</CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
    <CTableRow>
      <CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Business Name</CFormLabel></CTableDataCell>
      <CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Customer Name</CFormLabel></CTableDataCell>
      <CTableDataCell><CFormInput type="customerName" id="exampleFormControlInput1" aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Billing Address</CFormLabel></CTableDataCell>
      <CTableDataCell><CFormInput type="customerName" id="exampleFormControlInput1"  aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Billing Postcode</CFormLabel></CTableDataCell>
      <CTableDataCell><CFormInput type="customerName" id="exampleFormControlInput1" aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Contact Number</CFormLabel></CTableDataCell>
      <CTableDataCell><CFormInput type="customerName" id="exampleFormControlInput1"  aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Address</CFormLabel></CTableDataCell>
      <CTableDataCell><CFormInput type="customerName" id="exampleFormControlInput1"  /></CTableDataCell>
    </CTableRow>
    <CTableRow>
    <CDropdown>
  <CDropdownToggle  >Supply Details</CDropdownToggle>
  <CDropdownMenu>
    <CDropdownItem>Gas</CDropdownItem>
    <CDropdownItem>Electricity</CDropdownItem>
  </CDropdownMenu>
</CDropdown>
</CTableRow>
<div id='electricity'>
<CTableBody>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Billing Name*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Supply Address*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Supply Postcode*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Current Supplier*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Account Number</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>

</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Supply Number*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">MSN</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Contract End Date*</CFormLabel></CTableDataCell>
<CTableDataCell><DatePicker></DatePicker></CTableDataCell>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">EAC*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>

</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Billing Amount</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Meter Type</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>

<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Standing Charge</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Unit Rate</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Night Rate</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">EVE Weekend</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>

</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Capacity Charge</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">FIT Charge</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
</CTableBody>  
</div>
<div id='gas'>
<CTableBody>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Billing Name*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Supply Address*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Supply Postcode*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Current Supplier*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">MPR*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Contract End Date*</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Billing Amount</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>
<CTableRow>
<CTableDataCell><CFormLabel htmlFor="exampleFormControlInput1">Standing Charge</CFormLabel></CTableDataCell>
<CTableDataCell><CFormInput type="businessName" id="exampleFormControlInput1"  required aria-describedby="exampleFormControlInputHelpInline" /></CTableDataCell>
</CTableRow>

</CTableBody>  
</div>
  </CTableBody>
</CTable>
</CForm>
       
      </div>
);
} 


export default App;